/** @jsx jsx */

import React, { useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import renderBlock from 'services/apiHelpers/renderBlock';
import EditableBtn from 'components/lib/EditableBtn';
import getBlockById from 'services/apiHelpers/getBlockById';
import EditableText from 'components/lib/EditableText';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Audio from 'components/lib/Audio';
import imagePlaceholder from 'assets/Square.png';

const reRenderedFeedback = feedback =>
  feedback
    ? renderBlock(getBlockById(feedback.props.id), {
        EditableButton: EditableBtn,
        Feedback: ({ children, ...props }) => children,
        Correct: ({ children, ...props }) => children,
        Incorrect: ({ children, ...props }) => children,
        Text: EditableText,
        Image: ({ children, ...props }) => {
          return (
            <Image
              {...{
                ...props,
                placeholder: imagePlaceholder,
              }}
            />
          );
        },
        Video,
        Audio,
        Transcript: () => null,
        SVG,
        Embed,
        Media,
        PDF,
        OpenPDF,
      })
    : null;

export default reRenderedFeedback;
